import {Component, DestroyRef, inject, Input, OnDestroy, OnInit} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {BokkzIbDataService, IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import {filter, Observable, shareReplay, take} from "rxjs";
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overig-eigen-woning',
  templateUrl: './overig-eigen-woning.component.html',
  styleUrls: ['./overig-eigen-woning.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    AsyncPipe
  ]
})
export class OverigEigenWoningComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private readonly destroyRef = inject(DestroyRef);
  private readonly dataService = inject(BokkzIbDataService);

  readonly incomeTaxEntity$: Observable<IncomeTaxEntity> =
    this.dataService.incomeTaxEntity$.pipe(
      filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );


  public formGroup = new FormGroup({
    belastDeelKapitaalverzekeringEigenWoningen: new FormControl<number | null>(null),
    renteInVoorgaandeJarenBetaaldVoorDitJaar: new FormControl<number | null>(null),
    renteInDitJaarVoorAndereJaren: new FormControl<number | null>(null)
  })


  public ngOnInit(): void {
    this.incomeTaxEntity$.pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((data) => {
      this.formGroup.patchValue({belastDeelKapitaalverzekeringEigenWoningen: data.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.belastDeelKapitaalverzekeringEigenWoningen}, {emitEvent: false});
      this.formGroup.patchValue({renteInVoorgaandeJarenBetaaldVoorDitJaar: data.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.renteInVoorgaandeJarenBetaaldVoorDitJaar}, {emitEvent: false});
      this.formGroup.patchValue({renteInDitJaarVoorAndereJaren: data.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.renteInDitJaarVoorAndereJaren}, {emitEvent: false});
    });
  }

  ngOnDestroy(): void {
    this.saveForm();
    this.dataService.calculateLatestIncomeTaxReturn();
  }

  saveForm(): void {
    const rawValue = this.formGroup.getRawValue();

    this.dataService.patchIncomeTaxEntity(currentEntity => {
      if (!currentEntity.aangifte) {
        return currentEntity;
      }

      return {
        ...currentEntity,
        aangifte: {
          ...currentEntity.aangifte,
          box1: {
            ...currentEntity.aangifte.box1,
            belastbareInkomstenUitEigenWoning: {
              ...currentEntity.aangifte.box1?.belastbareInkomstenUitEigenWoning,
              belastDeelKapitaalverzekeringEigenWoningen: rawValue.belastDeelKapitaalverzekeringEigenWoningen ?? undefined,
              renteInVoorgaandeJarenBetaaldVoorDitJaar: rawValue.renteInVoorgaandeJarenBetaaldVoorDitJaar ?? undefined,
              renteInDitJaarVoorAndereJaren: rawValue.renteInDitJaarVoorAndereJaren ?? undefined,
            }
          }
        },
      } as IncomeTaxEntity;
    });
  }
}
